import localFont from "next/font/local"

// Core fonts that need Next.js optimization. Roboto Mono is our own copy (a variable font, 100 to
// 700): next/font/google fails the build when Google answers with font URLs without an extension.
const roboto_mono = localFont({
  display: "swap",
  preload: true,
  src: "../public/assets/fonts/roboto_mono/RobotoMono.ttf",
  style: "normal",
  variable: "--font-roboto",
  // 600 is the button weight of the new-community form (/form)
  weight: "100 700",
})

const blur = localFont({
  preload: true,
  src: [
    {
      path: "../public/assets/fonts/blur/Blur-Regular.ttf",
      weight: "400",
      style: "normal",
    },
    {
      path: "../public/assets/fonts/blur/Blur-Medium.otf",
      weight: "500",
      style: "normal",
    },
    {
      path: "../public/assets/fonts/blur/Blur-Bold.otf",
      weight: "700",
      style: "normal",
    },
  ],
  variable: "--font-blur",
})

// Export all font variables in an array for easy application
export const fontVariables = [roboto_mono.variable, blur.variable]
